export interface PhotoData {
	data: string;
	mime: "image/jpeg";
}

const PHOTO_MAX_SIZE = 1000;

export async function downscalePhoto(file: File): Promise<PhotoData> {
	const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
	const scale = Math.min(1, PHOTO_MAX_SIZE / Math.max(bitmap.width, bitmap.height));
	const width = Math.round(bitmap.width * scale);
	const height = Math.round(bitmap.height * scale);
	const canvas = document.createElement("canvas");
	canvas.width = width;
	canvas.height = height;

	const ctx = canvas.getContext("2d");

	if (ctx === null) {
		throw new Error("canvas-context-unavailable");
	}

	ctx.drawImage(bitmap, 0, 0, width, height);
	bitmap.close();

	const blob = await new Promise<Blob | null>((resolve) => {
		canvas.toBlob((b) => resolve(b), "image/jpeg", 0.85);
	});

	if (blob === null) {
		throw new Error("photo-encode-failed");
	}

	const buffer = await blob.arrayBuffer();
	const bytes = new Uint8Array(buffer);
	let binary = "";

	for (let i = 0; i < bytes.length; i++) {
		binary += String.fromCodePoint(bytes[i]);
	}

	return { data: btoa(binary), mime: "image/jpeg" };
}

export function photoDataUrl(photo: PhotoData) {
	return `data:${photo.mime};base64,${photo.data}`;
}
